import { RootAction } from '../../typings/rootActions';

export function setPlaylistIndexFromArticleId(id: number): RootAction {
  return { type: 'SET_PLAYLIST_INDEX_FROM_ARTICLE_ID', payload: id };
}

export function setPlaylistIndex(index: number): RootAction {
  return { type: 'SET_PLAYLIST_INDEX', payload: index };
}
